import { render, staticRenderFns } from "./PracticePeriodsTable.vue?vue&type=template&id=2214a4f4"
import script from "./PracticePeriodsTable.vue?vue&type=script&lang=ts"
export * from "./PracticePeriodsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports